import { render, staticRenderFns } from "./BottomNav.vue?vue&type=template&id=0007dd93&scoped=true&"
import script from "./BottomNav.vue?vue&type=script&lang=ts&"
export * from "./BottomNav.vue?vue&type=script&lang=ts&"
import style0 from "./BottomNav.vue?vue&type=style&index=0&id=0007dd93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0007dd93",
  null
  
)

export default component.exports